import * as React from 'react'
import { connect } from 'react-redux'

import {
	Form,
	Input,
	Label,
	Modal,
	Button,
	FormGroup,
	ModalBody,
	ModalFooter,
	ModalHeader
} from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { RootState } from 'src/store/rootReducer'
import { Employee } from 'src/lib/interfaces/Employee.interface'
import { JobApplicant } from 'src/lib/interfaces/JobApplicant.interface'

import * as employeesActions from 'src/store/employees/actions'
import * as applicationsActions from 'src/store/applications/actions'

import { formatName } from 'src/lib/helpers/format'

const isEmpty = require('lodash/isEmpty')

export interface ConvertApplicantToEmployeeModalProps {
	nextEmployeeId?: string
	isFetchingNextEmployeeId: boolean
	setCurrentEmployee: (employee?: Employee) => void
	fetchNextEmployeeId: (next?: (err?: any, nextEmployeeId?: string) => void) => void
	convertApplicationToEmployee: (applicationId: string, employeeId: string, next?: (err?: any, application?: JobApplicant) => void) => void
}

export interface ConvertApplicantToEmployeeModalPassedProps {
	open: boolean
	onClose: () => void
  application?: JobApplicant
}

interface ConvertApplicantToEmployeeModalState {
	employeeId?: string
	isConverting: boolean
}

class ConvertApplicantToEmployeeModal extends React.Component<
	ConvertApplicantToEmployeeModalProps & ConvertApplicantToEmployeeModalPassedProps,
	ConvertApplicantToEmployeeModalState
> {
	constructor(props) {
		super(props)

		this.state = {
			isConverting: false,
			employeeId: undefined
		}

		this.handleClose = this.handleClose.bind(this)
		this.handleSubmit = this.handleSubmit.bind(this)
		this.convertToEmployee = this.convertToEmployee.bind(this)
	}

	get applicantName() {
		const { application } = this.props

		if (application) {
			return formatName(application)
		}

		return null
	}

	componentDidUpdate(prevProps, prevState) {
		const { open, nextEmployeeId } = this.props
		const { open: prevOpen, nextEmployeeId: prevNextEmployeeId } = prevProps

		if (open && !prevOpen) {
			this.props.fetchNextEmployeeId()
		}

		if (nextEmployeeId && !prevNextEmployeeId) {
			this.setState({ employeeId: nextEmployeeId })
		}
	}

	handleClose() {
		this.props.onClose()
		this.setState({ employeeId: undefined, isConverting: false })
	}

	handleSubmit(e) {
		e.preventDefault()

		if (isEmpty(this.state.employeeId)) {
			return
		}

		this.setState({ isConverting: true }, this.convertToEmployee)
	}

	convertToEmployee() {
		const { employeeId } = this.state
		const { application, convertApplicationToEmployee } = this.props

		convertApplicationToEmployee(application!.id, employeeId!, (err?: any, convertedApplication?: JobApplicant) => {
			if (!err) {
				this.props.setCurrentEmployee(convertedApplication!.employee)
				this.handleClose()
			}
		})
	}

  render() {
		const { employeeId, isConverting } = this.state
    const { open, isFetchingNextEmployeeId } = this.props

    return (
      <Modal isOpen={open} toggle={this.handleClose}>
        <ModalHeader toggle={this.handleClose}>Convert <b>{this.applicantName}</b> to an Employee</ModalHeader>

        <ModalBody>
					<Form onSubmit={this.handleSubmit}>
						<FormGroup>
							<Label className="font-weight-bold text-secondary">Employee ID</Label>
							<Input
								value={employeeId || ''}
								placeholder="Employee ID"
								disabled={isFetchingNextEmployeeId}
								onChange={e => this.setState({ employeeId: e.target.value })}
							/>
						</FormGroup>
					</Form>
				</ModalBody>

				<ModalFooter>
					<Button color="light" onClick={this.handleClose}>Cancel</Button>
					<Button
						color="primary"
						onClick={this.handleSubmit}
						disabled={isConverting || isFetchingNextEmployeeId || isEmpty(employeeId)}
					>
						{isConverting && (
							<FontAwesomeIcon
								spin
								className="mr-3"
								icon={["fas", "spinner"]}
							/>
						)}
						Convert
					</Button>
				</ModalFooter>
      </Modal>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
	nextEmployeeId: state.applications.nextEmployeeId,
	isFetchingNextEmployeeId: state.applications.isFetchingNextEmployeeId
})

const mapDispatchToProps = dispatch => ({
	setCurrentEmployee: (employee?: Employee) => dispatch(employeesActions.setCurrentEmployee(employee)),
	fetchNextEmployeeId: (next?: (err?: any, nextEmployeeId?: string) => void) =>
		dispatch(applicationsActions.fetchNextEmployeeId(next)),
	convertApplicationToEmployee: (applicationId: string, employeeId: string, next?: (err?: any, application?: JobApplicant) => void) =>
		dispatch(applicationsActions.convertApplicationToEmployee(applicationId, employeeId, next))
})

export default connect<{}, {}, ConvertApplicantToEmployeeModalPassedProps>(
	mapStateToProps,
	mapDispatchToProps
)(ConvertApplicantToEmployeeModal)



// WEBPACK FOOTER //
// ./src/routes/applications/components/ConvertApplicantToEmployee.modal.tsx